import BeginnersGuideInviteMobile from '../Academy/BeginnersGuideInvite/BeginnersGuideInviteMobile';
import { useSelector } from 'react-redux';
import {
    getIsBeginnersGuideEnabledSelector,
    getIsShowBeginnersGuideInviteSelector,
    getIsTutorialsEnabledSelector,
} from './tutorialsSelectors';
import {
    getIsLocationPlatformDesktopSelector,
    getIsLocationPlatformMobileSelector,
} from '../Location/locationSelectors';
import BeginnersGuideInviteDesktop from '../Academy/BeginnersGuideInvite/BeginnersGuideInviteDesktop';
import useTutorialsBeginnersGuideInvite from './useTutorialsBeginnersGuideInvite';

function TutorialsProvider() {
    const isBeginnersGuideEnabled = useSelector(getIsBeginnersGuideEnabledSelector);
    const isTutorialsEnabled = useSelector(getIsTutorialsEnabledSelector);
    const isShowBeginnersGuideInvite = useSelector(getIsShowBeginnersGuideInviteSelector);
    const isMobilePlatform = useSelector(getIsLocationPlatformMobileSelector);
    const isDesktopPlatform = useSelector(getIsLocationPlatformDesktopSelector);
    const isAllowShowBeginnersGuideInvite = isTutorialsEnabled && isBeginnersGuideEnabled && isShowBeginnersGuideInvite;

    const inviteProps = useTutorialsBeginnersGuideInvite({ isAllowShow: isAllowShowBeginnersGuideInvite });

    return <>
        {
            isAllowShowBeginnersGuideInvite && <>
                {isMobilePlatform && <BeginnersGuideInviteMobile {...inviteProps}/>}
                {isDesktopPlatform && <BeginnersGuideInviteDesktop {...inviteProps}/>}
            </>
        }
    </>;
}

export default TutorialsProvider;
